module.exports = __webpack_public_path__ + "img/bg-sm-21.50bed6b4.jpg";